var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('h3',{staticClass:"fz-16 yx-pingfang-semibold yx-color-text-primary",class:[_vm.required ? 'required' : '']},[_vm._v(_vm._s(_vm.title))]),(_vm.subTitle)?_c('p',{staticClass:"mt-8 yx-color-text-regular fz-12"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }